// Site core › widgets: the shared public widgets and the pages that stand in
// for the site (#1122): closed and paused league pages, the Fan AI bubble,
// the lightbox, the off-sport toast, the public bracket, the ScoreLM badge,
// the sport switcher and the Turnstile notice.

const en = {
  /** The league is switched off (is_active=false). */
  closed: {
    /** The league's name until the tenant loads. */
    nameFallback: 'This site',
    badge: 'Currently closed',
    headline: 'is taking a break',
    body: "The site is paused for now. Check back soon — we'll be back online before you know it.",
  },
  /** The league's subscription isn't live. */
  inactive: {
    badge: 'Subscription inactive',
    headline: 'is paused',
    body: "This site is paused — the league's subscription is inactive. The league's administrators can reactivate it from the admin portal.",
    adminLink: 'Admin log in →',
  },
  fanAi: {
    launcher: (assistantName: string) => `Ask ${assistantName}`,
    close: 'Close',
    subtitle: 'League assistant',
    send: 'Send',
    placeholder: 'Ask anything about the league',
    placeholderBusy: 'Thinking…',
    placeholderUnavailable: 'Assistant unavailable',
    unavailableNotice: (assistantName: string) => `${assistantName} isn’t available right now. Please check back later.`,
    unavailable: 'The assistant isn’t available right now.',
    connectionLost: 'Connection lost.',
    connectionLostRetry: 'Connection lost. Try again?',
    error: {
      generic: 'Something went wrong.',
      rateLimited: 'Daily limit reached.',
      budgetExhausted: 'Assistant is on a break.',
      tooLong: 'That question is too long — try shortening it.',
      noBody: 'No response body.',
    },
    /** What the assistant is doing while it fetches data (shown with "…"). */
    tool: {
      thinking: 'Thinking',
      standings: 'Checking standings',
      nextGames: 'Looking up upcoming games',
      recentResults: 'Pulling recent results',
      gameResult: 'Looking up that game',
      statLeaders: 'Fetching stat leaders',
      playerStats: 'Loading player stats',
      searchPlayers: 'Searching players',
      teamInfo: 'Looking up team',
      headToHead: 'Comparing head-to-head',
      leagueOverview: 'Reading league overview',
      other: 'Looking that up',
    },
  },
  lightbox: {
    close: 'Close',
    previous: 'Previous image',
    next: 'Next image',
    /** "3 / 12" */
    position: (n: number, total: number) => `${n} / ${total}`,
  },
  /** A detail page switched the site to the record's sport. */
  offSport: {
    title: (sportName: string) => `Switched to ${sportName}`,
    /** `noun` is the record kind: player, team, game, live event, page, sponsor, venue. */
    body: (noun: string, sportName: string) => `The ${noun} you're viewing is ${sportName.toLowerCase()}-only.`,
    dismiss: 'Dismiss',
  },
  bracket: {
    unknownTeam: 'Unknown',
    view: 'View',
    legendWinner: 'Winner',
    legendTbd: '= To Be Determined',
    scrollHint: '← Scroll horizontally to see full bracket →',
  },
  badge: {
    poweredBy: 'Powered by ScoreLM',
  },
  sportSwitcher: {
    label: 'Sport',
  },
  /** A Growth preview (Ops › Growth): the bar its signed-in lead sees on every page. */
  preview: {
    label: 'Your ScoreLM preview',
    until: (date: string) => `Your ScoreLM preview, until ${date}.`,
    keep: 'To keep it, reply to our email or talk to us.',
    admin: 'Edit in admin',
    talk: 'Talk to us',
    hide: 'Hide',
  },
  turnstile: {
    /** Dev builds without a site key; the variable name stays in a <code>. */
    notConfigured: (envVar: string) => `Turnstile is not configured (${envVar} unset). Submissions will be rejected by the server.`,
  },
}

export default en
